import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import CommentDataAttrDiv from '../../../../lego/CommentDataAttrDiv';
import s from './RootLayout.scss';
const RootLayout = (_param)=>/*#__PURE__*/ {
    var { className , contentBlocks , prefix  } = _param, rest = _object_without_properties(_param, [
        "className",
        "contentBlocks",
        "prefix"
    ]);
    return React.createElement(CommentDataAttrDiv, _extends({
        className: c(s['root'], className)
    }, rest), prefix, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, contentBlocks));
};
RootLayout.displayName = 'RootLayout';
export default RootLayout;
